/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `src/translations
 *
 * If 'language' is an empty string, the language is set on the user locale with fallback to English.
 * Actually supported languages: 'cs', 'de', 'en', 'hr', 'hu', 'it', 'pl', 'ro', 'sk', 'sl', 'el', 'sq'.
 */

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import moment from 'moment'
import { getBankFromPath } from 'Utility/bankMethods'
import { getLanguage } from 'Utility/globalMethods'

// Components
import 'moment/locale/bs'
import 'moment/locale/cs'
import 'moment/locale/de'
import 'moment/locale/el'
import 'moment/locale/en-gb'
import 'moment/locale/hr'
import 'moment/locale/hu'
import 'moment/locale/it'
import 'moment/locale/pl'
import 'moment/locale/ro'
import 'moment/locale/sk'
import 'moment/locale/sl'
import 'moment/locale/sq'
import 'moment/locale/sr'
import { DEFAULT_BANK, DEFAULT_LANG } from 'Schemas/constants'
import { bankTranslationMessages } from 'Translations'

export function LanguageProvider(props) {
  const [translationMessages, setTranslationMessage] = useState(null)
  let locale = getLanguage()
  let bank = getBankFromPath() || DEFAULT_BANK

  if (!bankTranslationMessages?.[bank]?.[locale]) {
    locale = DEFAULT_LANG
  }
  
  moment.locale(bankTranslationMessages[bank][locale].momentLocale)

  useEffect(() => {
    const translationMessages = { ...bankTranslationMessages[bank][locale].appStrings }
    Object.keys(translationMessages).forEach((key) => {
      const message = translationMessages[key]
      const updatedMessage = message.replace(/<br\s*\/?>/gi, '{br}')
      translationMessages[key] = updatedMessage
    })
    setTranslationMessage(translationMessages)
  }, [locale])

  return translationMessages && (
    <IntlProvider locale={locale} key={locale} messages={translationMessages}>
      {React.Children.only(props.children)}
    </IntlProvider>
  )
}

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired
}

LanguageProvider.defaultProps = {}

export default LanguageProvider